import { queryOptions } from '@tanstack/react-query';
import { type GetCycledEnergyResponse } from '../types/battery-monitoring-api';
import { batteryMonitoringApi } from '../battery-monitoring-api';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- queryOptions as return type should be inferred
export const getVehiclesQueryOptions = () => {
  return queryOptions<GetCycledEnergyResponse>({
    queryKey: ['getVehicles'],
    queryFn: async () => await batteryMonitoringApi.getVehicles(),
  });
};
